import {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
  type JSX,
} from 'react';

import './ScalingContentWrapper.sass';

type Props = {
  className?: string;
  children?: (string | JSX.Element)[] | string | JSX.Element;
  naturalWidth?: number;
};

const ScalingContentWrapper: FunctionComponent<Props> = ({
  className,
  children,
  naturalWidth = 1000,
}: Props): JSX.Element => {
  const [scaleRatio, setScaleRatio] = useState(1);
  const [updateAspectRatioTrigger, setUpdateAspectRatioTrigger] =
    useState<Date>();

  const outerRef = useRef<HTMLDivElement>(null);
  const innerRef = useRef<HTMLDivElement>(null);

  const calculateScaleRatio = useCallback(() => {
    setScaleRatio(
      (outerRef?.current?.offsetWidth || 0) /
        (innerRef?.current?.offsetWidth || 0)
    );
  }, [outerRef?.current?.offsetWidth, innerRef?.current?.offsetWidth]);

  useEffect(() => {
    calculateScaleRatio();
    setUpdateAspectRatioTrigger(new Date());
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'calculateScaleRatio'
  }, [
    outerRef?.current?.offsetWidth,
    outerRef?.current?.offsetHeight,
    innerRef?.current?.offsetWidth,
    innerRef?.current?.offsetHeight,
    children,
  ]);

  const aspectRatio = useMemo(() => {
    const offsetWidth = innerRef?.current?.offsetWidth || 0;

    if (offsetWidth == 0) return 1;

    return (
      (innerRef?.current?.offsetHeight || 0) /
      (innerRef?.current?.offsetWidth || 0)
    );
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has unnecessary dependency: updateAspectRatioTrigger
  }, [
    innerRef?.current?.offsetWidth,
    innerRef?.current?.offsetHeight,
    updateAspectRatioTrigger,
  ]);

  useEffect(() => {
    window.addEventListener('resize', calculateScaleRatio);

    return () => {
      window.removeEventListener('resize', calculateScaleRatio);
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'calculateScaleRatio'
  }, []);

  return (
    <div
      className={`scaling-content-wrapper ${className ? className : ''}`}
      ref={outerRef}
      style={{ paddingTop: `${aspectRatio * 100}%` }}
    >
      <div
        className="scaling-content-wrapper-inner"
        ref={innerRef}
        style={{ transform: `scale(${scaleRatio})`, width: naturalWidth }}
      >
        {children}
      </div>
    </div>
  );
};

export default ScalingContentWrapper;
